import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonAPIService } from '../commonAPI.service';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { AcpResponseAPI } from '../../shared/models/recipe/recipe-acp.model';
import { FieldFilter } from '../../shared/models/search.model';

@Injectable({
  providedIn: 'root',
})
export class AcpRecipeSearchService extends CommonAPIService {
  constructor(http: HttpClient, configService: ConfigService) {
    super(configService, http);
  }

  acpRecipeSearch(fieldFilters: FieldFilter[], market: string, lang: string, query: string): Observable<AcpResponseAPI> {
    return this.post<AcpResponseAPI>('recipes/acp/' + '?lang=' + lang + '&market=' + market + '&q=' + query, { fieldFilters });
  }
}
